export default {"src":"/_next/static/media/gamingLogo1.93f82ebf.svg","height":90,"width":79,"blurWidth":0,"blurHeight":0};